export default __webpack_public_path__ + "static/media/croc.a004368e.jpg";